import { passwordRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const passwordRouteMetadata: IRouteMetadataObj<typeof passwordRoutesObj> = {
  reset: {
    title: "resetPassword.create.title",
    description: "resetPassword.create.description",
    lazy: () => import("@/pages/userManagement/password/reset/form/page"),
    mode: "create",
    type: "inner",
    icon: "LockLine",
    breadcrumbs: [],
    permission,
  },
};

export const passwordRoutes = createRoute<typeof passwordRoutesObj>(
  passwordRoutesObj,
  passwordRouteMetadata,
);
